import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { CHARGE_CATEGORY, CHARGE_STATUS, CHARGE_TYPE } from 'src/features/charges/utils/types';
import { chargesMessages } from 'src/features/charges/utils/messages';

export const CHARGE_TYPE_BADGE_OPTIONS: Record<CHARGE_TYPE, BadgeOption> = {
    [CHARGE_TYPE.INVOICE]: {
        label: chargesMessages.invoice,
        icon: ICON_MAP.INVOICE,
        theme: 'blue',
    },
    [CHARGE_TYPE.DEBIT]: {
        label: chargesMessages.debit,
        icon: ICON_MAP.PLUS_CIRCLE,
        theme: 'green',
    },
    [CHARGE_TYPE.CREDIT]: {
        label: chargesMessages.credit,
        icon: ICON_MAP.MINUS_CIRCLE,
        theme: 'red',
    },
};

export const CHARGE_CATEGORY_BADGE_OPTIONS: Record<CHARGE_CATEGORY, BadgeOption> = {
    [CHARGE_CATEGORY.ONE_TIME]: {
        label: chargesMessages.oneTime,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [CHARGE_CATEGORY.SUB]: {
        label: chargesMessages.chargeCategorySub,
        icon: ICON_MAP.FROZEN,
        theme: 'gray',
    },
    [CHARGE_CATEGORY.VOUCHER]: {
        label: chargesMessages.voucher,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
    [CHARGE_CATEGORY.DISCOUNT]: {
        label: chargesMessages.discount,
        icon: ICON_MAP.FROZEN,
        theme: 'blue',
    },
};

export const CHARGE_TYPE_MAP: Record<CHARGE_TYPE, { id: string; defaultMessage: string }> = {
    [CHARGE_TYPE.INVOICE]: chargesMessages.invoice,
    [CHARGE_TYPE.DEBIT]: chargesMessages.debit,
    [CHARGE_TYPE.CREDIT]: chargesMessages.credit,
};

export const CHARGE_CATEGORY_MAP: Record<CHARGE_CATEGORY, { id: string; defaultMessage: string }> = {
    [CHARGE_CATEGORY.ONE_TIME]: chargesMessages.oneTime,
    [CHARGE_CATEGORY.SUB]: chargesMessages.chargeCategorySub,
    [CHARGE_CATEGORY.VOUCHER]: chargesMessages.voucher,
    [CHARGE_CATEGORY.DISCOUNT]: chargesMessages.discount,
};

export const CHARGE_STATUS_BADGE_OPTIONS: Record<CHARGE_STATUS, BadgeOption> = {
    [CHARGE_STATUS.PENDING]: {
        label: chargesMessages.pending,
        icon: ICON_MAP.FROZEN,
        theme: 'gray',
    },
    [CHARGE_STATUS.INVOICED]: {
        label: chargesMessages.invoiced,
        icon: ICON_MAP.CHECK,
        theme: 'green',
    },
    [CHARGE_STATUS.VOIDED]: {
        label: chargesMessages.voided,
        icon: ICON_MAP.X_MARK,
        theme: 'red',
    },
    [CHARGE_STATUS.REFUNDED]: {
        label: chargesMessages.refunded,
        icon: ICON_MAP.FROZEN,
        theme: 'blue',
    },
};

export const CHARGE_STATUS_TRANSLATION_MAP: Record<CHARGE_STATUS, { id: string; defaultMessage: string }> = {
    [CHARGE_STATUS.PENDING]: chargesMessages.pending,
    [CHARGE_STATUS.VOIDED]: chargesMessages.voided,
    [CHARGE_STATUS.INVOICED]: chargesMessages.invoiced,
    [CHARGE_STATUS.REFUNDED]: chargesMessages.refunded,
};
